var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVad = function SvgVad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "vad_svg__st0",
    d: "M23.1 8.8h-3.3c.5 1 .7 2.2.7 3.4 0 4.4-3.4 8.1-7.8 8.5v2.5c0 .5.4.9.9.9h7.5c1.6 0 2.9-1.3 2.9-2.9V9.6c0-.4-.4-.8-.9-.8zM3.5 12.2c0-1.2.3-2.4.7-3.4H.8c-.4 0-.8.3-.8.8v11.6C0 22.7 1.3 24 2.8 24h7.6c.5 0 .8-.4.8-.8v-2.5c-4.3-.5-7.7-4.1-7.7-8.5zM7.2 5.1V.7c0-.4-.3-.7-.6-.7H2.7C1.2 0 0 1.2 0 2.7v3.9c0 .4.3.7.7.7h4.4c.6-.9 1.3-1.6 2.1-2.2zM12 3.7c1.2 0 2.2.2 3.3.6V.5c0-.3-.3-.5-.6-.5H9.3c-.3 0-.6.2-.6.5v3.8c1.1-.4 2.1-.6 3.3-.6zM21.2 0h-3.6c-.5 0-.8.4-.8.8v4.3c.9.6 1.6 1.3 2.2 2.1h4.3c.5 0 .8-.4.8-.8V2.8C24 1.3 22.7 0 21.2 0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.4 11.8v1.3c0 3-2.4 5.4-5.4 5.4s-5.4-2.4-5.4-5.4v-1.3H8v1.3c0 2.2 1.8 4 4 4s4-1.8 4-4v-1.3h1.4zm-2.7 1.4c0 1.5-1.2 2.7-2.7 2.7s-2.7-1.2-2.7-2.7V8.5c0-1.5 1.2-2.7 2.7-2.7s2.7 1.2 2.7 2.7v4.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgVad;